(function($) {

	$.fn.msxiDownloadPanel = function() {

		return this.each(function() {
			var $this = $(this);

            // Attachments / Documents - Panel
            $this.find('.document-checkbox-selection').click(function () {
                var selectionSizeMB = 0;
                $this.find(".document-checkbox-selection:checked").each(function () {
                    selectionSizeMB = selectionSizeMB + $(this).data("filesize")/1024/1024;
                });

                if ($this.find(".document-checkbox-selection:checked").size() > 0) {
                    $this.find(".document-checkbox-selection").addClass('visible');
                }else{
                    $this.find(".document-checkbox-selection").removeClass('visible');
                }

                var sizeLimitMB = $this.find("#download-selection-button").data("sizelimitmb");
                if (selectionSizeMB > 0 && selectionSizeMB < sizeLimitMB) {
                    enableDownloadLink($this.find("#download-selection-button"));
                }else if(selectionSizeMB === 0){
                    disableDownloadLink($this.find("#download-selection-button"), "No files selected");
                }else{
                    disableDownloadLink($this.find("#download-selection-button"), "The combined files' size exceeds the limit allowed");
                }
            });

            $this.find('#download-selection-button').click(function (e) {
                e.preventDefault();
                var selection = $this.find(".document-checkbox-selection:checked").map(function () {
                    return $(this).val();
                }).get();

                if (selection.length > 0) {
                    var href = $(this).attr('href') + '&selection=' + selection;
                    $.getGo(href, null);
                }
            });

            // Default behaviour for the selection button, as the page load will be unselected
            disableDownloadLink($this.find("#download-selection-button"), "No files selected");
        });
	};

    function disableDownloadLink(node, title) {
        if (!node.data("disabled")) {
            node.data("href", node.attr("href"))
                .attr("href", "javascript:void(0)")
                .data("title", node.attr("title"))
                .attr("aria-disabled", "true")
                .data("disabled", "true")
                .addClass("disabled");
        }
        node.attr("title", title);
    }

    function enableDownloadLink(node) {
        if (node.data("disabled")) {
            node.attr("href", node.data("href"))
                .attr("title", node.data("title"))
                .removeData("disabled")
                .removeClass("disabled");
        }
    }

})(jQuery);